// Master list of standard PT/OT/ST CPT codes used across the app.
// Used in BillingRules (code search modal) and Coding (extended_codes API param).
export const CPT_CODES = [
  {
    code: '97110',
    desc: 'Therapeutic exercise',
    cat: 'Therapeutic procedures',
  },
  {
    code: '97112',
    desc: 'Neuromuscular reeducation',
    cat: 'Therapeutic procedures',
  },
  { code: '97116', desc: 'Gait training', cat: 'Therapeutic procedures' },
  {
    code: '97130',
    desc: 'Cognitive skills development',
    cat: 'Therapeutic procedures',
  },
  {
    code: '97140',
    desc: 'Manual therapy techniques',
    cat: 'Therapeutic procedures',
  },
  {
    code: '97150',
    desc: 'Therapeutic procedure, group',
    cat: 'Therapeutic procedures',
  },
  {
    code: '97530',
    desc: 'Therapeutic activities',
    cat: 'Therapeutic procedures',
  },
  {
    code: '97535',
    desc: 'Self-care / home management training',
    cat: 'Therapeutic procedures',
  },
  {
    code: '97542',
    desc: 'Wheelchair management training',
    cat: 'Therapeutic procedures',
  },
  {
    code: '97750',
    desc: 'Physical performance test or measurement',
    cat: 'Tests and measurements',
  },
  {
    code: '97760',
    desc: 'Orthotic management and training',
    cat: 'Orthotics and prosthetics',
  },
  {
    code: '97761',
    desc: 'Prosthetic training',
    cat: 'Orthotics and prosthetics',
  },
  { code: '97012', desc: 'Mechanical traction', cat: 'Modalities' },
  { code: '97016', desc: 'Vasopneumatic device therapy', cat: 'Modalities' },
  { code: '97018', desc: 'Paraffin bath', cat: 'Modalities' },
  { code: '97022', desc: 'Whirlpool therapy', cat: 'Modalities' },
  { code: '97032', desc: 'Electrical stimulation attended', cat: 'Modalities' },
  { code: '97033', desc: 'Iontophoresis', cat: 'Modalities' },
  { code: '97034', desc: 'Contrast bath therapy', cat: 'Modalities' },
  { code: '97035', desc: 'Ultrasound therapy', cat: 'Modalities' },
  { code: '97161', desc: 'PT evaluation low complexity', cat: 'Evaluations' },
  {
    code: '97162',
    desc: 'PT evaluation moderate complexity',
    cat: 'Evaluations',
  },
  { code: '97163', desc: 'PT evaluation high complexity', cat: 'Evaluations' },
  { code: '97164', desc: 'PT re-evaluation', cat: 'Evaluations' },
  { code: '97165', desc: 'OT evaluation low complexity', cat: 'Evaluations' },
  {
    code: '97166',
    desc: 'OT evaluation moderate complexity',
    cat: 'Evaluations',
  },
  { code: '97167', desc: 'OT evaluation high complexity', cat: 'Evaluations' },
  { code: '97168', desc: 'OT re-evaluation', cat: 'Evaluations' },
  {
    code: '92507',
    desc: 'Speech language hearing treatment',
    cat: 'Speech therapy',
  },
  { code: '92508', desc: 'Speech treatment group', cat: 'Speech therapy' },
  {
    code: '92521',
    desc: 'Evaluation of speech fluency',
    cat: 'Speech therapy',
  },
  {
    code: '92522',
    desc: 'Evaluation of speech sound production',
    cat: 'Speech therapy',
  },
  {
    code: '92523',
    desc: 'Evaluation of speech sound production with language comprehension',
    cat: 'Speech therapy',
  },
  {
    code: '92524',
    desc: 'Behavioral and qualitative analysis of voice',
    cat: 'Speech therapy',
  },
  { code: '92520', desc: 'Laryngeal function studies', cat: 'Speech therapy' },
  { code: '92526', desc: 'Oral function therapy', cat: 'Speech therapy' },
  {
    code: '92597',
    desc: 'Oral speech device evaluation',
    cat: 'Speech therapy',
  },
  {
    code: '92607',
    desc: 'AAC device examination, first hour',
    cat: 'Speech therapy',
  },
  {
    code: '92608',
    desc: 'AAC device examination, each additional 30 min',
    cat: 'Speech therapy',
  },
  { code: '92609', desc: 'AAC device service', cat: 'Speech therapy' },
  {
    code: '92610',
    desc: 'Evaluation of oral and pharyngeal swallowing function',
    cat: 'Speech therapy',
  },
  {
    code: '92611',
    desc: 'Motion fluoroscopy / modified barium swallow',
    cat: 'Speech therapy',
  },
  {
    code: '92612',
    desc: 'Flexible endoscopic evaluation of swallowing (FEES)',
    cat: 'Speech therapy',
  },
  {
    code: '92614',
    desc: 'Laryngoscopic sensory testing',
    cat: 'Speech therapy',
  },
  {
    code: '92616',
    desc: 'FEES with laryngeal sensory testing',
    cat: 'Speech therapy',
  },
  { code: '96105', desc: 'Assessment of aphasia', cat: 'Speech therapy' },
  { code: '97026', desc: 'Infrared therapy', cat: 'Modalities' },
  { code: '97010', desc: 'Hot or cold packs', cat: 'Modalities' },
  { code: '97024', desc: 'Diathermy', cat: 'Modalities' },
  { code: '97028', desc: 'Ultraviolet therapy', cat: 'Modalities' },
  { code: '97036', desc: 'Hydrotherapy', cat: 'Modalities' },
  {
    code: '97039',
    desc: 'Unlisted physical therapy modality',
    cat: 'Modalities',
  },
  {
    code: 'G0283',
    desc: 'Electrical stimulation, other than wound care',
    cat: 'Modalities',
  },
  {
    code: '97113',
    desc: 'Aquatic therapy',
    cat: 'Therapeutic procedures',
  },
  { code: '97124', desc: 'Massage therapy', cat: 'Therapeutic procedures' },
  {
    code: '97129',
    desc: 'Therapeutic intervention, cognitive function, first 15 min',
    cat: 'Therapeutic procedures',
  },
  {
    code: '97537',
    desc: 'Community/work reintegration training',
    cat: 'Therapeutic procedures',
  },
  { code: '97533', desc: 'Sensory integration', cat: 'Therapeutic procedures' },
  {
    code: '90901',
    desc: 'Biofeedback training',
    cat: 'Therapeutic procedures',
  },
  {
    code: '90912',
    desc: 'Biofeedback training, first 15 min',
    cat: 'Therapeutic procedures',
  },
  {
    code: '90913',
    desc: 'Biofeedback training, each additional 15 min',
    cat: 'Therapeutic procedures',
  },
  {
    code: '93797',
    desc: 'Cardiac rehabilitation',
    cat: 'Therapeutic procedures',
  },
  {
    code: '93798',
    desc: 'Cardiac rehabilitation with ECG monitoring',
    cat: 'Therapeutic procedures',
  },
  {
    code: '95992',
    desc: 'Canalith repositioning procedure',
    cat: 'Therapeutic procedures',
  },
  {
    code: '95851',
    desc: 'Range of motion measurements',
    cat: 'Tests and measurements',
  },
  {
    code: '95852',
    desc: 'Range of motion measurements, hand/fingers',
    cat: 'Tests and measurements',
  },
  {
    code: '96000',
    desc: 'Motion analysis, video/3D',
    cat: 'Tests and measurements',
  },
  {
    code: '96001',
    desc: 'Motion analysis with foot pressure measurement',
    cat: 'Tests and measurements',
  },
  {
    code: '96002',
    desc: 'Dynamic surface EMG',
    cat: 'Tests and measurements',
  },
  {
    code: '96125',
    desc: 'Cognitive testing by healthcare professional',
    cat: 'Tests and measurements',
  },
  {
    code: '97755',
    desc: 'Assistive technology assessment',
    cat: 'Tests and measurements',
  },
  {
    code: 'G0451',
    desc: 'Developmental test interpretation and report',
    cat: 'Tests and measurements',
  },
  {
    code: '97763',
    desc: 'Orthotic/prosthetic management, subsequent encounter',
    cat: 'Orthotics and prosthetics',
  },
  {
    code: '97545',
    desc: 'Work hardening, first 2 hours',
    cat: 'Work conditioning',
  },
  {
    code: '97546',
    desc: 'Work hardening, each additional hour',
    cat: 'Work conditioning',
  },
  {
    code: '97550',
    desc: 'Caregiver training in therapeutic intervention, first 30 min',
    cat: 'Caregiver training',
  },
  {
    code: '97551',
    desc: 'Caregiver training, each additional 15 min',
    cat: 'Caregiver training',
  },
  {
    code: '97552',
    desc: 'Group caregiver training',
    cat: 'Caregiver training',
  },
  {
    code: 'G0541',
    desc: 'Caregiver training, no patient present, initial 30 min',
    cat: 'Caregiver training',
  },
  {
    code: 'G0542',
    desc: 'Caregiver training, no patient present, each additional 15 min',
    cat: 'Caregiver training',
  },
  {
    code: 'G0543',
    desc: 'Group caregiver training without patient present',
    cat: 'Caregiver training',
  },
  {
    code: '97597',
    desc: 'Wound debridement, selective, ≤20 cm²',
    cat: 'Wound care',
  },
  {
    code: '97598',
    desc: 'Wound debridement, selective, each additional 20 cm²',
    cat: 'Wound care',
  },
  {
    code: '97602',
    desc: 'Wound care, non-selective debridement',
    cat: 'Wound care',
  },
  {
    code: '97605',
    desc: 'Negative pressure wound therapy, ≤50 cm²',
    cat: 'Wound care',
  },
  {
    code: '97606',
    desc: 'Negative pressure wound therapy, >50 cm²',
    cat: 'Wound care',
  },
  {
    code: '97607',
    desc: 'Negative pressure wound therapy, disposable device, ≤50 cm²',
    cat: 'Wound care',
  },
  {
    code: '97608',
    desc: 'Negative pressure wound therapy, disposable device, >50 cm²',
    cat: 'Wound care',
  },
  {
    code: '97610',
    desc: 'Low frequency non-thermal ultrasound',
    cat: 'Wound care',
  },
  {
    code: 'G0281',
    desc: 'Electrical stimulation, unattended, for pressure ulcers',
    cat: 'Wound care',
  },
  {
    code: 'G0329',
    desc: 'Electromagnetic therapy for chronic ulcers',
    cat: 'Wound care',
  },
  {
    code: '97139',
    desc: 'Unlisted physical medicine procedure',
    cat: 'Unlisted / Other',
  },
  {
    code: '97799',
    desc: 'Unlisted physical medicine/rehabilitation procedure',
    cat: 'Unlisted / Other',
  },
  {
    code: '98975',
    desc: 'Remote therapeutic monitoring setup and patient education',
    cat: 'Remote therapeutic monitoring',
  },
  {
    code: '98976',
    desc: 'RTM device supply, respiratory system, 16-30 days',
    cat: 'Remote therapeutic monitoring',
  },
  {
    code: '98977',
    desc: 'RTM device supply, musculoskeletal system, 16-30 days',
    cat: 'Remote therapeutic monitoring',
  },
  {
    code: '98979',
    desc: 'RTM treatment management, first 10 min',
    cat: 'Remote therapeutic monitoring',
  },
  {
    code: '98980',
    desc: 'RTM treatment management, first 20 min per calendar month',
    cat: 'Remote therapeutic monitoring',
  },
  {
    code: '98981',
    desc: 'RTM treatment management, each additional 20 min',
    cat: 'Remote therapeutic monitoring',
  },
  {
    code: '98984',
    desc: 'RTM device supply, respiratory system, 2-15 days',
    cat: 'Remote therapeutic monitoring',
  },
  {
    code: '98985',
    desc: 'RTM device supply, musculoskeletal system, 2-15 days',
    cat: 'Remote therapeutic monitoring',
  },
  {
    code: '98966',
    desc: 'Phone assessment & management, non-physician, 5-10 min',
    cat: 'Telehealth / Phone',
  },
  {
    code: '98967',
    desc: 'Phone assessment & management, non-physician, 11-20 min',
    cat: 'Telehealth / Phone',
  },
  {
    code: '98968',
    desc: 'Phone assessment & management, non-physician, 21-30 min',
    cat: 'Telehealth / Phone',
  },
  {
    code: '98970',
    desc: 'Online digital assessment & management, 5-10 min',
    cat: 'Telehealth / Phone',
  },
  {
    code: '98971',
    desc: 'Online digital assessment & management, 11-20 min',
    cat: 'Telehealth / Phone',
  },
  {
    code: '98972',
    desc: 'Online digital assessment & management, 21+ min',
    cat: 'Telehealth / Phone',
  },
  {
    code: 'G2250',
    desc: 'Remote image submission by patient, non-E/M',
    cat: 'Telehealth / Phone',
  },
  {
    code: 'G2251',
    desc: 'Brief check-in, 5-10 min, non-E/M',
    cat: 'Telehealth / Phone',
  },
];
